<div class="dashboard-container">
	<div class="heading">
		<app-page-title title="Dashboard"></app-page-title>
	</div>

	<div class="content">
		<ng-container *ngIf="noOrganisationAvailable; else organisationAvailable">
			<app-incomplete-organisation-banner />
		</ng-container>

		<ng-template #organisationAvailable>
			<ng-container *ngIf="isMobileSize; else desktopLayout">
				<div class="dashboard-container">
					<ng-container *ngIf="isOwner">
						<app-radio-group-control class="heading" [formGroup]="form" name="view" [options]="radioOptions" />

						<ng-container [ngSwitch]="selectedMobileView">
							<app-latest-leads-table
								*ngSwitchCase="DashboardViewOptions.LEADS"
								class="content"
								[leads]="latestLeads"
								[isLoading]="leadsLoading"
							/>
							<ng-container *ngSwitchCase="DashboardViewOptions.SCHEDULE">
								<ng-container *ngTemplateOutlet="scheduleTable" />
							</ng-container>
						</ng-container>
					</ng-container>

					<ng-container *ngIf="!isOwner">
						<ng-container *ngTemplateOutlet="scheduleTable" />
					</ng-container>
				</div>
			</ng-container>

			<ng-template #desktopLayout>
				<div class="items-container">
					<div *ngIf="isOwner" class="item">
						<app-latest-leads-table [leads]="latestLeads" [isLoading]="leadsLoading" />
					</div>
					<div class="item">
						<app-schedule-table
							[isLoading]="assessmentsLoading"
							[navigationConfig]="navigationConfig"
							[(selectedStep)]="selectedStep"
							[assessments]="assessments"
							(selectedStepChange)="fetchCurrentAssessments($event)"
						/>
					</div>
				</div>
			</ng-template>
		</ng-template>

		<ng-template #scheduleTable>
			<app-schedule-table
				class="content"
				[isLoading]="assessmentsLoading"
				[navigationConfig]="navigationConfig"
				[(selectedStep)]="selectedStep"
				[assessments]="assessments"
				(selectedStepChange)="fetchCurrentAssessments($event)"
			/>
		</ng-template>
	</div>
</div>
